import React from 'react';
import Main from './views/main.c';
import {SSRDataContext} from '../../helpers/SSRDataContext';

export default function HomeNewWithSSR(props) {
    return (
        <SSRDataContext.Consumer>
            {ssrData => <Main {...props} ssrData={ssrData} />}
        </SSRDataContext.Consumer>
    );
}
